import React from 'react';
import { styled } from '@mui/material';
import { green } from '@mui/material/colors';

type StyledButtonProps = {
  isActive: boolean;
};

const StyledButton = styled('button', {
  shouldForwardProp: (propName: string) => !['isActive', 'as'].includes(propName),
})(({ isActive }: StyledButtonProps) => ({
  appearance: 'none',
  boxShadow: isActive ? `inset 0 4px 0 0 ${green[600]}` : 'none',
  cursor: 'pointer',
  '&:focus': {
    outline: 'none',
  },
  '&:hover': {
    backgroundColor: `${green[50]}`,
  },
  background: 'transparent',
  border: 0,
  padding: 0,
  margin: 0,
  width: '25%',
}));

export const PanelTab: React.FC<React.HTMLProps<HTMLButtonElement> & { active: boolean }> = ({
  active,
  ...otherProps
}) => {
  return <StyledButton {...otherProps} isActive={active} as='button' type='button' />;
};
